import { clsx } from 'clsx';
import { FC } from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  BareAccordion,
} from 'atoms/BareAccordion';
import { IconSVG } from 'atoms/IconSVG';
import { IAccordion } from './types';
import styles from './Accordion.module.css';

export const Accordion: FC<IAccordion> = ({
  children,
  summaryContent,
  classes,
  invertArrow,
  headingColor = 'white',
  ...accordionProps
}) => {
  const {
    details = '',
    content = '',
    bareRoot = '',
    bareExpanded = '',
    summaryRoot = '',
    summaryExpanded = '',
    icon = '',
  } = classes || {};
  return (
    <BareAccordion
      component="div"
      transition="none"
      classes={{
        root: clsx(styles.accordionRoot, bareRoot),
        expanded: clsx(styles.rootExpanded, bareExpanded),
        heading: clsx(styles.heading, styles[headingColor]),
      }}
      slotProps={{ heading: { component: 'h2' } }}
      {...accordionProps}
    >
      <AccordionSummary
        classes={{
          root: clsx(styles.summaryRoot, summaryRoot),
          content: clsx(styles.summaryContent, content),
          expanded: clsx(styles.expanded, summaryExpanded),
          disabled: styles.disabled,
        }}
        expandIcon={
          <IconSVG
            type="arrowDown"
            className={clsx(
              styles.arrow,
              icon,
              invertArrow && styles.arrowInverted,
            )}
          />
        }
      >
        {summaryContent}
      </AccordionSummary>
      <AccordionDetails classes={{ root: clsx(styles.detailsRoot, details) }}>
        {children}
      </AccordionDetails>
    </BareAccordion>
  );
};
